import { Controller } from "@hotwired/stimulus"
import CriiptoAuth from "@criipto/auth-js"

export default class extends Controller {
  static values = {
    domain: String,
    clientId: String,
    redirectUri: String,
    callbackUri: String,
    acrValues: { type: String, default: "urn:grn:authn:no:bankid:substantial" },
    autoRedirect: { type: Boolean, default: false },
  }

  static targets = ["spinner", "button"]

  connect() {
    this.criiptoAuth = new CriiptoAuth({
      domain: this.domainValue,
      clientID: this.clientIdValue,
      store: sessionStorage,
    })

    if (this.isCallback()) {
      this.handleCallback()
    } else if (this.autoRedirectValue) {
      this.startRedirect()
    }
  }

  isCallback() {
    const params = new URLSearchParams(window.location.search)
    const hash = new URLSearchParams(window.location.hash.replace("#", "?"))
    return params.has("code") || params.has("id_token") || hash.has("id_token")
  }

  startRedirect() {
    if (this.hasButtonTarget) this.buttonTarget.hidden = true
    if (this.hasSpinnerTarget) this.spinnerTarget.hidden = false

    this.criiptoAuth.redirect.authorize({
      redirectUri: this.callbackUriValue,
      acrValues: this.acrValuesValue,
      prompt: "login",
      scope: "openid ssn",
      uiLocales: "nb",
    })
  }

  login() {
    this.startRedirect()
  }

  async handleCallback() {
    try {
      const result = await this.criiptoAuth.redirect.match()

      if (result && result.id_token) {
        const response = await fetch(this.redirectUriValue, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": this.csrfToken(),
          },
          body: JSON.stringify({ id_token: result.id_token }),
        })

        if (response.ok) {
          const data = await response.json()
          window.location.href = data.location || "/orders"
        } else {
          this.showError("Autentisering mislyktes. Vennligst prøv igjen.")
        }
      } else {
        this.showError("Ingen autentiseringsdata mottatt.")
      }
    } catch (error) {
      console.error("Idura callback error:", error)
      this.showError("Noe gikk galt. Vennligst prøv igjen.")
    }
  }

  showError(message) {
    this.element.innerHTML = `
      <div class="card w-96 bg-base-200 shadow-xl">
        <div class="card-body items-center text-center">
          <p class="text-error">${message}</p>
          <a href="/login" class="btn btn-secondary mt-4">Prøv igjen</a>
        </div>
      </div>
    `
  }

  csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.getAttribute("content") : ""
  }
}
